import React from 'react';
import { FONT_BODY } from './theme';
import { FEATURES, FeatureDef } from './data';
import { Kicker } from './ui';
import { FeatureIcon } from './icons';

export const FeatureCard: React.FC<{ feature: FeatureDef }> = ({ feature }) => (
  <div
    className="sm1p-feature-card"
    style={{ background: '#fff', border: '1px solid #E7EEF9', borderRadius: 16, padding: 22 }}
  >
    <span
      style={{
        display: 'flex',
        width: 48,
        height: 48,
        borderRadius: 14,
        background: feature.tileBg,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 14,
      }}
    >
      <FeatureIcon feature={feature} />
    </span>
    <h3
      style={{
        font: `700 16.5px/1.32 ${FONT_BODY}`,
        color: '#0F172A',
        margin: 0,
        letterSpacing: '-.015em',
      }}
    >
      {feature.title}
    </h3>
    <p style={{ font: `400 13.5px/1.6 ${FONT_BODY}`, color: '#64748B', margin: '9px 0 0' }}>{feature.desc}</p>
  </div>
);

const Features: React.FC = () => (
  <section id="features" style={{ scrollMarginTop: 74, padding: 'clamp(26px,3.2vw,44px) clamp(16px,4vw,30px)' }}>
    <div style={{ maxWidth: 1180, margin: '0 auto' }}>
      <Kicker align="center">One connected ecosystem</Kicker>
      <h2
        style={{
          font: `800 clamp(25px,3.4vw,36px)/1.18 ${FONT_BODY}`,
          letterSpacing: '-.032em',
          color: '#0F172A',
          margin: '14px 0 0',
          textAlign: 'center',
          textWrap: 'balance',
        }}
      >
        One school. One connected AI ecosystem.
      </h2>
      <p
        style={{
          font: `400 clamp(14px,1.25vw,16px)/1.6 ${FONT_BODY}`,
          color: '#475569',
          margin: '11px auto 0',
          textAlign: 'center',
          maxWidth: '62ch',
        }}
      >
        30+ AI roles across marketing, admissions, academics, parents, fees and operations — every one of them working
        to your roadmap.
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,240px),1fr))',
          gap: 16,
          margin: '28px 0 0',
        }}
      >
        {FEATURES.map((f) => (
          <FeatureCard key={f.title} feature={f} />
        ))}
      </div>
    </div>
  </section>
);

export default Features;
